<template>
  <div>
    <label :for="id" v-text="label" />
    <div class="row">
      <div class="col-auto">
        <button @click.prevent="decrement">-</button>
      </div>
      <div class="col">
        <p class="current" v-text="formattedValue" />
      </div>
      <div class="col-auto">
        <button @click.prevent="increment">+</button>
      </div>
    </div>
    <input
      :id="id"
      v-model="value"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      :name="name"
      class="custom-range mt-2"
    />
  </div>
</template>

<script>
import wNumb from "wnumb"
import { clamp } from "lodash"

export default {
  props: ["min", "max", "step", "label", "name", "default"],

  data() {
    return {
      id: null,
      value: this.default || this.max / 2
    }
  },

  computed: {
    formattedValue() {
      const moneyFormat = wNumb({
        thousand: ",",
        prefix: this.$currency
      })

      return moneyFormat.to(parseInt(this.value))
    }
  },

  mounted() {
    // eslint-disable-next-line
      this.id = this._uid
  },

  methods: {
    decrement() {
      this.value = clamp(
        parseInt(this.value) - parseInt(this.step),
        parseInt(this.min),
        parseInt(this.max)
      )
    },
    increment() {
      this.value = clamp(
        parseInt(this.value) + parseInt(this.step),
        parseInt(this.min),
        parseInt(this.max)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.current {
  font-weight: 700;
  font-size: 1.625rem;
  color: #042d68;
  text-align: center;
}

label {
  color: #8a90a3;
  display: block;
  text-align: center;
  font-size: 0.9375rem;
}

button {
  border: 1px solid #042d68;
  background: #fff;
  border-radius: 5px;
  width: 2.5rem;
  height: 2.5rem;
  font-weight: 400;
  font-size: 1.5rem;
  color: #042d68;
  transition: all 0.3s ease;

  &:hover {
    background: #042d68;
    border-color: #042d68;
    color: #fff;
  }
}
</style>
